import React, { useEffect } from 'react';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import { useWidget } from 'components/Widget/useWidget';
import ninjaApi from 'store/redux/apis/ninja.api';
import ChartBody from 'modules/DashboardModule/charts/components/ChartBody';
import ChartLoading from 'components/charts/components/ChartLoading';
import NoResultFound from 'components/charts/components/NoResultFound';

const PostbackChart = ({ height }) => {
  const { filters, chartConfig, widget_key } = useWidget();
  const { date_from, date_to } = useWidgetDate(widget_key);

  const [getDashboardPostbackReports, { data: list = [], isLoading, isFetching }] =
    ninjaApi.useLazyDashboardPostbackReportsQuery();

  useEffect(() => {
    const params = {
      date_from: date_from,
      date_to: date_to,
      ...filters,
    };

    if (chartConfig?.load_chart) {
      params.group_by = 'date';
    }

    if (params?.date_from) {
      getDashboardPostbackReports(params)
        .unwrap()
        .then(() => {});
    }
  }, [filters, chartConfig?.load_chart, date_to]);

  if (isLoading || isFetching) {
    return <ChartLoading height={height} />;
  }

  if (!list?.data?.length) {
    return <NoResultFound height={height} />;
  }

  return <ChartBody height={height} data={list.data} />;
};

export default PostbackChart;
